export class Comparators {
    public static naturalOrderForNumber(a: number, b: number): number {
        return a - b
    }

    public static reverseOrderForNumber(a: number, b: number): number {
        return b - a
    }
}
